export const INVALID_PERCENTAGE_DISCOUNT_MESSAGE =
  'Percentage discount must be between 0 and 100'

export const INVALID_AMOUNT_DISCOUNT_MESSAGE =
  'Amount discount must be less than Regular MRP'

function parseCsvLine(line) {
  const result = []
  let current = ''
  let inQuotes = false

  for (let i = 0; i < line.length; i++) {
    const char = line[i]
    const nextChar = line[i + 1]

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        current += '"'
        i += 1
      } else {
        inQuotes = !inQuotes
      }
    } else if (char === ',' && !inQuotes) {
      result.push(current.trim())
      current = ''
    } else {
      current += char
    }
  }

  result.push(current.trim())
  return result
}

function normalizeHeader(header) {
  return String(header || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
}

function toFiniteNumber(value) {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

export function isInvalidAmountDiscount(discountType, discountValue, regularMrp) {
  const type = String(discountType || '')
    .toLowerCase()
    .trim()
  if (type !== 'amount') return false
  const value = toFiniteNumber(discountValue)
  const mrp = toFiniteNumber(regularMrp)
  if (value === null || mrp === null) return false
  return value >= mrp
}

export function isInvalidPercentageDiscount(discountType, discountValue) {
  const type = String(discountType || '')
    .toLowerCase()
    .trim()
  if (type !== 'percentage') return false
  const value = toFiniteNumber(discountValue)
  if (value === null) return false
  return value < 0 || value > 100
}

function getRowField(row, ...keys) {
  for (const key of keys) {
    if (row[key] !== undefined && row[key] !== null && String(row[key]).trim() !== '') {
      return row[key]
    }
  }
  return ''
}

/**
 * Validate promotion CSV discount values against Regular MRP / percentage bounds.
 * Returns row-level error messages; does not block on missing columns (backend handles those).
 */
export function validatePromotionCsvDiscounts(csvText) {
  const lines = String(csvText || '')
    .split(/\r\n|\r|\n/)
    .map((line) => line.trim())
    .filter(Boolean)

  if (lines.length < 2) {
    return []
  }

  const headers = parseCsvLine(lines[0]).map(normalizeHeader)
  const errors = []

  for (let i = 1; i < lines.length; i++) {
    const values = parseCsvLine(lines[i])
    const row = {}
    headers.forEach((header, index) => {
      row[header] = values[index] || ''
    })

    const discountType = getRowField(row, 'discount_type')
    const discountValue = getRowField(row, 'discount_value')
    const regularMrp = getRowField(row, 'regular_mrp')
    const rowNumber = i + 1

    if (isInvalidPercentageDiscount(discountType, discountValue)) {
      errors.push(`Row ${rowNumber}: ${INVALID_PERCENTAGE_DISCOUNT_MESSAGE}`)
      continue
    }

    if (isInvalidAmountDiscount(discountType, discountValue, regularMrp)) {
      errors.push(`Row ${rowNumber}: ${INVALID_AMOUNT_DISCOUNT_MESSAGE}`)
    }
  }

  return errors
}
